module.exports = __webpack_public_path__ + "static/media/remi_french.52c3ea90.mp3";